// extracted by mini-css-extract-plugin
export var externalLink = "_d9-0";
export var internalLinkLabel = "_d9-1";